import { isIframed } from '../helpers/iframe'

export default class KelvinDataLayer {
  constructor () {
    this.events = []
    this.config = null
  }

  #getConfig () {
    if (this.config) return this.config
    const body = document.body
    this.config = {
      iframeOrigin: body.dataset.kelvinDataLayerIframeOrigin || null,
      gtmEnabled: body.dataset.kelvinDataLayerGtmEnabled === 'true',
      pianoEnabled: body.dataset.kelvinDataLayerPianoEnabled === 'true'
    }
    return this.config
  }

  #forwardToParent (event) {
    const { iframeOrigin } = this.#getConfig()
    if (!iframeOrigin || !isIframed()) return
    iframeOrigin.split(',').forEach(origin => {
      window.parent.postMessage(event, origin.trim())
    })
  }

  #forwardToGtm (event) {
    if (!this.#getConfig().gtmEnabled) return
    if (typeof window.dataLayer === 'undefined') {
      window.dataLayer = []
    }
    window.dataLayer.push({ ...event, event: event.message })
  }

  #forwardToPiano (payload) {
    if (!this.#getConfig().pianoEnabled) return
    if (typeof window.pa === 'undefined') return
    if (!payload || !payload.piano) return
    const piano = payload.piano
    const pageProps = {
      page: piano.page || document.title,
      page_type: piano.page_type,
      page_subtype: piano.page_subtype,
      page_category1_id: piano.page_category1_id
    }
    if (piano.event_type === 'button.click') {
      window.pa.sendEvent('button.click', {
        ...pageProps,
        button_name: piano.button_name
      })
    } else {
      window.pa.sendEvent('page.display', pageProps)
    }
  }

  push (event, payload = {}) {
    this.events.push(event)
    this.#forwardToParent(event)
    this.#forwardToGtm(event)
    this.#forwardToPiano(payload)
  }
}
